import { render, staticRenderFns } from "./_RejectDetail.vue?vue&type=template&id=ba125dec&scoped=true"
import script from "./_RejectDetail.vue?vue&type=script&lang=ts"
export * from "./_RejectDetail.vue?vue&type=script&lang=ts"
import style0 from "./_RejectDetail.vue?vue&type=style&index=0&id=ba125dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba125dec",
  null
  
)

export default component.exports